import React, { Component } from 'react';
import {
  Checkbox, Dropdown, Menu, Popover,
} from 'antd';
import { Input, CustomIcon } from 'view/common';
import EDIT from 'assets/img/addrEdit.png';
import DELETE from 'assets/img/addrDelete.png';
import SUBMIT from 'assets/img/addrSubmit.png';
import UNVALIDATED from 'assets/img/unvalidated.png';
import OK from 'assets/img/ok.svg';
import SEARCH from 'assets/img/search.svg';
import ARROW from 'assets/img/play_arrow.svg';
import SEARCH_DARK from 'assets/img/black/search.svg';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import cx from 'classnames';
import './style.scss';
import { connect } from 'react-redux';

const addressList = [
  { id: 0, unvalidated: true },
  { id: 1 },
  { id: 2 },
];

const FilterDropdown = () => (
  <Menu onSelect={() => { }}>
    <Menu.Item key="1">1st menu item</Menu.Item>
    <Menu.Item key="2">2nd menu item</Menu.Item>
    <Menu.Item key="3">3rd item</Menu.Item>
  </Menu>
);

const ActionsDropdown = () => (
  <Menu onSelect={() => { }}>
    <Menu.Item key="1">Export</Menu.Item>
    <Menu.Item key="2">Delete</Menu.Item>
    <Menu.Item key="3">Override</Menu.Item>
  </Menu>
);

const AddressItem = props => (
  <div
    className={cx('addressContainer', {
      checked: props.checked,
    })}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
    onFocus={props.onFocus}
  >
    <div style={{ display: 'flex' }}>
      {props.unvalidated
        ? (
          <img
            style={{
              width: '16px',
              height: '16px',
              margin: '0 14px',
              padding: '0',
            }}
            src={UNVALIDATED}
            alt=""
          />
        )
        : (
          <div style={{
            width: '16px',
            height: '16px',
            margin: '0 14px',
            padding: '0',
          }}
          />
        )
      }
      <Checkbox onChange={props.handleCheckbox} checked={props.checked}>
        <span>
          {!props.editMode ? '123 S. Main St. Corona, Ca 92882' : ''}
        </span>
      </Checkbox>
    </div>
    {props.editMode
      && (
        <Input
          inputProps={{
            type: 'text',
            name: 'addressSearchValue',
            placeholder: 'Search Address',
            value: props.addressSearchValue,
            onChange: props.handleInput,
            style: {
              padding: '7px 12px 6px 35px',
            },
          }}
          style={{ margin: '0' }}
          dropdownVisible={props.dropdownVisible}
          iconSrc={SEARCH}
          dropdownOptions={props.dropdownOptions}
        />
      )
    }
    <div
      className={cx('options', {
        optionsVisible: props.hovered,
      })}
    >
      <img
        className={cx({ filtered: props.editMode })}
        onClick={!props.editMode && props.handleEditAddress}
        src={EDIT}
        alt=""
      />
      <Popover
        placement="bottomLeft"
        title="Delete this address?"
        trigger={['click']}
        content={(
          <div className="popoverContent">
            <span>No</span>
            <span>Yes</span>
          </div>
        )}
      >
        <img
          onClick={props.handleDeleteAddress}
          src={DELETE}
          alt=""
        />
      </Popover>
      <img
        onClick={props.handleSubmitAddress}
        src={SUBMIT}
        alt=""
      />
    </div>
  </div>
);

class EditAddresses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedIds: [],
      editModeId: null,
      hoveredId: null,
      allChecked: false,
    };
  }

  handleCheckbox = (id) => {
    this.setState((p) => {
      const { checkedIds } = p;
      const newState = {};
      if (checkedIds.includes(id)) {
        checkedIds.splice(checkedIds.indexOf(id), 1);
        newState.checkedIds = checkedIds;
      } else {
        checkedIds.push(id);
        newState.checkedIds = checkedIds;
      }

      newState.allChecked = !(newState.checkedIds.length < addressList.length);
      return newState;
    });
  };

  handleEdit = editModeId => this.setState({ editModeId });

  handleCheckAll = () => {
    this.setState(p => ({ checkedIds: [], allChecked: !p.allChecked }));

    if (this.state.allChecked) return;

    const checkedIds = addressList.map(it => it.id);
    this.setState({ checkedIds, allChecked: true });
  };

  render() {
    const {
      handleDeleteAddress,
      handleSubmitAddress,
      addressSearchValue,
      handleInput,
      dropdownVisible,
      dropdownOptions,
      isDarkTheme,
    } = this.props;
    const {
      checkedIds,
      editModeId,
      hoveredId,
    } = this.state;
    return (
      <div className="modalContent">
        <h1>Project Addresses</h1>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        >
          <Dropdown
            style={{ height: '41px' }}
            trigger={['click']}
            overlay={(
              <FilterDropdown
                chooseFilter={() => { }}
                filter={this.props.providerFilter}
              />)}
          >
            <div className="providers_dropdown">
              <span>Filter by</span> <CustomIcon src={isDarkTheme ? ARROW_BLUE : ARROW} width="8px" height="10px" />
            </div>
          </Dropdown>

          <Input
            style={{ width: '40%' }}
            inputProps={{
              type: 'text',
              name: 'addressSearchValue',
              placeholder: 'Search Address',
              value: addressSearchValue,
              onChange: handleInput,
            }}
            dropdownVisible={dropdownVisible}
            iconSrc={isDarkTheme ? SEARCH_DARK : SEARCH}
            dropdownOptions={dropdownOptions}
          />
        </div>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        >
          <Checkbox style={{ marginLeft: '60px' }} onChange={this.handleCheckAll} checked={this.state.allChecked}>
            <p>Select all</p>
          </Checkbox>
          <Dropdown
            style={{ height: '41px' }}
            trigger={['click']}
            overlay={(
              <ActionsDropdown
                chooseFilter={() => { }}
                filter={this.props.providerFilter}
              />)}
          >
            <div className="providers_dropdown">
              <span>Filter by</span> <CustomIcon src={isDarkTheme ? ARROW_BLUE : ARROW} width="8px" height="10px" />
            </div>
          </Dropdown>
        </div>
        <div className="addressList">
          {addressList.map(it => (
            <AddressItem
              key={it.id}
              checked={checkedIds.includes(it.id)}
              onMouseEnter={() => this.setState({ hoveredId: it.id })}
              onMouseLeave={() => this.setState({ hoveredId: null })}
              onFocus={() => { }}
              hovered={hoveredId === it.id}
              editMode={editModeId === it.id}
              handleCheckbox={() => this.handleCheckbox(it.id)}
              handleEditAddress={() => this.handleEdit(it.id)}
              handleDeleteAddress={handleDeleteAddress}
              handleSubmitAddress={handleSubmitAddress}
              unvalidated={it.unvalidated}
            />
          ))}
        </div>
        <div className="footer">
          <div className="legend">
            <div className="legendItem">
              <img src={UNVALIDATED} alt="" />
              <p>Unvalidated Address</p>
            </div>
            <div className="legendItem">
              <img src={OK} alt="" />
              <p>Overriden Address</p>
            </div>
          </div>
          <div className="pagination">
            <p className="active">1</p>
            <p>2</p>
            <p>3</p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isDarkTheme: state.app.isDarkTheme,
});

const Connected = connect(mapStateToProps)(EditAddresses);
export { Connected as EditAddresses };



// WEBPACK FOOTER //
// ./src/view/screens/ModalBodies/EditAddresses.js